import type { SelectOptionCtx } from '@cli-types/next-adapter/generators.js'

export function buildSelectOptionStaticOptions(ctx: SelectOptionCtx): string {
  const entries = ctx.creatableSelectFields
    .map((field) => {
      const options = (field.options ?? [])
        .map(
          (option) =>
            `{ label: ${JSON.stringify(option.label)}, value: ${JSON.stringify(option.value)} }`
        )
        .join(', ')
      return `  ${JSON.stringify(field.name)}: [${options}]`
    })
    .join(',\n')

  return `const STATIC_SELECT_OPTIONS = {\n${entries}\n} as const`
}
